import { render } from "./Press.vue?vue&type=template&id=76f17719&scoped=true"
import script from "./Press.vue?vue&type=script&lang=ts"
export * from "./Press.vue?vue&type=script&lang=ts"

import "./Press.vue?vue&type=style&index=0&id=76f17719&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-76f17719"

export default script